export default class EventDesc {
  constructor() {
    this.readMore = document.querySelector('.read-more')
    this.readLess = document.querySelector('.read-less')
    this.extDesc = document.querySelector('.long-description')

    this.toggleReadMore = this.toggleReadMore.bind(this)
    this.toggleReadLess = this.toggleReadLess.bind(this)
    this.init = this.init.bind(this)
    this.init()
  }

  init() {
    if (this.extDesc) {
      this.readMore.addEventListener('click', ev => this.toggleReadMore())
      this.readLess.addEventListener('click', ev => this.toggleReadLess())
    }
  }

  toggleReadMore() {
    this.extDesc.classList.add('long-description-open')
    this.extDesc.classList.remove('long-description-closed')
    this.readMore.classList.add('hidden')
    this.readLess.classList.remove('hidden')
  }
  toggleReadLess() {
    this.extDesc.classList.remove('long-description-open')
    this.extDesc.classList.add('long-description-closed')
    this.readLess.classList.add('hidden')
    this.readMore.classList.remove('hidden')
  }
}